import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MeetingVisibilityDto } from '@interfaces/meetings/responses/meeting-visibility.response';
import { audienceIcons } from '@features/dashboard/meetings/components/meeting-visibility-presenter';

/**
 * Coluna "Quem vê" da lista de Meetings (card 3803): três ícones (Time, Parceiro, Cliente) em quatro
 * estados (vê, não vê, barrada pelo Cog, Cog avaliando), com o motivo do backend no tooltip.
 * Só exibe; sem `visibility` (visão do parceiro) não desenha nada.
 */
@Component({
  selector: 'app-meeting-visibility-icons',
  standalone: true,
  templateUrl: './meeting-visibility-icons.component.html',
  styleUrl: './meeting-visibility-icons.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeetingVisibilityIconsComponent {
  readonly visibility = input<MeetingVisibilityDto | null | undefined>(null);

  protected readonly icons = computed(() => audienceIcons(this.visibility()));

  /** Texto lido pelo leitor de tela: as três chaves, uma por frase. */
  protected readonly ariaLabel = computed(() =>
    this.icons()
      .map(icon => icon.tooltip)
      .join(' ')
  );
}
